import React from 'react';
import { videos } from '../../data/content';
import { ButtonLink } from '../ui/ButtonLink';
export function FeaturedVideo() {
  const video = videos[0];
  return <section aria-labelledby="featured-title" className="w-full bg-ink" data-id="element-57" data-mp="6tv3d4iqry20">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-5 py-24 md:px-10 lg:grid-cols-12 lg:items-center lg:gap-14 lg:py-32" data-id="element-58" data-mp="brmuhwbkbg55">
        <div className="lg:col-span-8" data-id="element-59" data-mp="3f7u0wald3rhm">
          <video src={`${video.src}#t=0.5`} controls preload="metadata" playsInline className="aspect-video w-full rounded-sm bg-stage" aria-label={`${video.artist} – ${video.title}, ${video.context}`} data-id="element-60" data-mp="3f8vdiji10m1g" />
        </div>
        <div className="lg:col-span-4" data-id="element-61" data-mp="3txrp2qjakh6t">
          <p className="text-sm text-amber" data-id="element-62" data-mp="3tyjche2qj8m0">Uitgelicht</p>
          <h2 id="featured-title" className="mt-4 font-serif text-5xl leading-[1.02] tracking-tight text-paper" data-id="element-63" data-mp="2wgatzso7vtab">
            <em data-id="element-64" data-mp="31euls9phrzal">{video.title}</em>, in eigen arrangement.
          </h2>
          <p className="mt-6 text-[17px] leading-relaxed text-sand" data-id="element-65" data-mp="ucsmd419dxvg">
            Voor mijn afstudeerconcert aan het Conservatorium van Amsterdam arrangeerde ik {video.artist}’s{' '}
            <em data-id="element-66" data-mp="km7q3n9255fp">{video.title}</em>. Liever eerst horen dan lezen? Dit is een goed begin.
          </p>
          <ButtonLink to="/beeld" variant="outline" arrow className="mt-8" data-id="element-67" data-mp="glnsyjohi1tk">
            Meer beeld &amp; geluid
          </ButtonLink>
        </div>
      </div>
    </section>;
}